import React, { useContext, useEffect, useState } from 'react';
import useShiftService from '../../../app/services/hooks/useShiftService';
import LazyLoading from '../../../components/LazyLoading';

import { ShiftDataForm } from '../../../app/models/Shift';
import ShiftFormContainer from './ShiftFormContainer';
import { AppContext } from '../../../contexts/AppContext';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';

interface Props {
    shiftId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const ShiftEdit = ({ shiftId, onSaved, onCancel, onError }: Props) => {
    const { fetchingEditShift, editShift, fetchingUpdateShift, updateShift } = useShiftService();
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [errorFields, setErrorFields] = useState<any>();
    const [shift, setShift] = useState<ShiftDataForm>({ name: '' });
    const [shiftWorkdays, setShiftWorkdays] = useState<[]>([]);
    const [eventTypes, setEventTypes] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando turno...');
        editShift(shiftId, {
            onSuccess: (response: ServiceResponse) => {
                setShift(response.data.shift);
                setShiftWorkdays(response.data.work_days);
                setEventTypes(response.data.event_types);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando feriado...');
        updateShift(shiftId, shift, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditShift ? (
        <LazyLoading height="300" />
    ) : (
        <ShiftFormContainer
            fetching={fetchingUpdateShift}
            action={update}
            cancel={cancel}
            shift={shift}
            workdays={shiftWorkdays}
            setShift={setShift}
            eventTypes={eventTypes}
            errorFields={errorFields}
        />
    );
};

export default ShiftEdit;
